import React, { useState } from "react";
import type { Meeting } from '../../../shared/src/types/Meeting';

interface PreviousMeetingsProps {
  meetings: Meeting[];
  onUpdateMeeting: (id: string, updatedData: Partial<Meeting>) => Promise<void>;
    refreshMeetings: () => Promise<void>;

}

const PreviousMeetings: React.FC<PreviousMeetingsProps> = ({
  meetings,
  onUpdateMeeting,
  refreshMeetings,
}) => {
  const [editingMeetingId, setEditingMeetingId] = useState<string | null>(null);
  const [formData, setFormData] = useState<Partial<Meeting>>({});

  const handleEditClick = (meeting: Meeting) => {
    setEditingMeetingId(meeting.id);
    setFormData({
      date: meeting.date,
      location: meeting.location,
      attendees: meeting.attendees,
    });
  };

  const handleSave = async () => {
    if (!editingMeetingId) return;
    try {
      await onUpdateMeeting(editingMeetingId, formData);
      setEditingMeetingId(null);
    } catch {
      alert("שגיאה בעדכון הפגישה");
    }
  };

  const handleChange = (field: keyof Meeting, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <table>
      <thead>
        <tr>
          <th>מספר פגישה</th>
          <th>תאריך</th>
          <th>מיקום</th>
          <th>משתתפים</th>
          <th>פעולות</th>
        </tr>
      </thead>
      <tbody>
        {meetings.map((meeting) => {
          const isEditing = editingMeetingId === meeting.id;

          return (
            <tr key={meeting.id}>
              <td>{meeting.meeting_number}</td>
              <td>
                {isEditing ? (
                  <input
                    type="datetime-local"
                    value={formData.date?.slice(0, 16) || ""}
                    onChange={(e) => handleChange("date", e.target.value)}
                  />
                ) : (
                  new Date(meeting.date).toLocaleString()
                )}
              </td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    value={formData.location || ""}
                    onChange={(e) => handleChange("location", e.target.value)}
                  />
                ) : (
                  meeting.location
                )}
              </td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    value={formData.attendees?.join(", ") || ""}
                    onChange={(e) =>
                      handleChange(
                        "attendees",
                        e.target.value.split(",").map((p) => p.trim())
                      )
                    }
                  />
                ) : (
                  meeting.attendees.join(", ")
                )}
              </td>
              <td>
                {isEditing ? (
                  <>
                    <button onClick={handleSave}>שמור</button>
                    <button onClick={() => setEditingMeetingId(null)}>ביטול</button>
                  </>
                ) : (
                  <button onClick={() => handleEditClick(meeting)}>ערוך</button>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default PreviousMeetings;
